module.exports = __webpack_public_path__ + "img/img06.6c97bcab.png";